import { render } from "./goodsLogBox.vue?vue&type=template&id=dd5973ac&scoped=true"
import script from "./goodsLogBox.vue?vue&type=script&lang=js"
export * from "./goodsLogBox.vue?vue&type=script&lang=js"

import "./goodsLogBox.vue?vue&type=style&index=0&id=dd5973ac&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd5973ac"]])

export default __exports__